const authentication = (state) => state.authentication;

const decodedAuthentication = (state) => state.decodedAuthentication;

const userRole = (state) => state.userRole;

const organisations = (state) => state.organisations;

const selectedOrganisation = (state) => state.selectedOrganisation;

const logSources = (state) => state.logSources;

const grokPatterns = (state) => state.grokPatterns;

const products = (state) => state.products;

const tokenResetTimestamp = (state) => state.tokenResetTimestamp;

const menuCollapsed = (state) => state.menuCollapsed;

const listCollapsed = (state) => state.listCollapsed;

export default {
  authentication,
  decodedAuthentication,
  userRole,
  organisations,
  selectedOrganisation,
  logSources,
  grokPatterns,
  products,
  tokenResetTimestamp,
  menuCollapsed,
  listCollapsed,
};
